import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/memberVisitsSaga";
import { useDateFormat } from "../../../../hooks/useDateFormat";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";

const SingleDatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();
  const date = useSelector((state) => state.memberVisits.selectedFilters.date);
  const { calendarEndDate } = useSelector((state) => state.memberVisits.currentUser);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      calendarEndDate={calendarEndDate}
      startDate={date}
      updateDates={(data) => dispatch(actionCreators.updateFilter({ key: "date", data }))}
    />
  );
};
export default SingleDatePicker;
